<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    scrollable
    :max-width="`${width}px`"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon flat @click="$emit('cancel')">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title>{{ titleDialog }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu v-if="profil.role == 'ADMIN'" bottom left>
          <v-btn slot="activator" dark icon>
            <v-icon>library_add</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="trainerDivisiInputDialog = true">
              <v-list-tile-avatar>
                <v-icon>star</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>Divisi</v-list-tile-title>
              <trainer-divisi-input
                :dialog="trainerDivisiInputDialog"
                title="TRAINER_DIVISI"
                action="ADD"
                primary_key="id_trainer_divisi"
                primary_field="trainer_divisi"
                @cancel="trainerDivisiInputDialog = false"
                @submitted="trainerDivisiInputDialog = false"
              >
              </trainer-divisi-input>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn icon :dark="!sameInput" :disabled="sameInput" @click="submit">
          <v-icon>save</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="height: 1000px">
        <v-form>
          <v-text-field
            v-if="dialog"
            autofocus
            append-icon="directions_run"
            type="text"
            v-model="input.trainer"
            v-validate="'required'"
            name="trainer"
            data-vv-name="trainer"
            label="Nama Trainer"
            data-vv-as="Nama Trainer"
            :error-messages="errors.collect('trainer')"
          >
          </v-text-field>
          <v-select
            append-icon="star"
            attach
            item-text="trainer_divisi"
            item-value="id_trainer_divisi"
            :items="trainer_divisi"
            v-model="input.id_trainer_divisi"
            v-validate="'required'"
            name="id_trainer_divisi"
            data-vv-name="id_trainer_divisi"
            label="Divisi Trainer"
            data-vv-as="Divisi Trainer"
            :error-messages="errors.collect('id_trainer_divisi')"
          >
          </v-select>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import _ from "lodash";
import TrainerDivisiInput from "@/components/pages/input/TrainerDivisiInput";
import { mapState } from "vuex";

const defaultInput = {
  trainer: "",
  id_trainer_divisi: ""
};

export default {
  name: "trainer-input",
  components: {
    TrainerDivisiInput
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    },
    action: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    primary_key: {
      type: String,
      default: ""
    },
    primary_field: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      input: _.cloneDeep(defaultInput),
      dataInjected: null,
      trainerDivisiInputDialog: false
    };
  },
  computed: {
    ...mapState(["status"]),
    ...mapState("auth", ["profil"]),
    ...mapState("trainer_divisi", ["trainer_divisi"]),
    source() {
      return this.$store.state[this.primary_field][this.primary_field];
    },
    titleDialog() {
      let title = this.action == "ADD" ? "TAMBAH" : "EDIT";
      return `${title} ${this.title}`;
    },
    sameInput() {
      return _.isEqual(this.input, this.dataInjected);
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(noError => {
        if (noError) {
          this.$store
            .dispatch(
              `${this.primary_field}/${this.action}_${this.title}`,
              this.input
            )
            .then(() => {
              let new_id =
                this.action == "ADD"
                  ? _.last(this.source)[this.primary_key]
                  : null;
              this.$emit("submitted", new_id);
            })
            .catch();
        } else {
          this.$store.commit(
            "ERROR",
            "Ada field yang masih error, cek kembali isian form!"
          );
        }
      });
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$validator.reset();
        if (this.action == "ADD") {
          this.dataInjected = _.cloneDeep(defaultInput);
        } else {
          this.dataInjected = _.cloneDeep(this.data);
        }
        this.input = _.cloneDeep(this.dataInjected);
      }
    }
  },
  mounted() {
    this.$store.dispatch("trainer/GET_TRAINER");
    this.$store.dispatch("trainer/GET_OPTIONS");
    this.$store.dispatch("trainer_divisi/GET_TRAINER_DIVISI");
  }
};
</script>
